/**
 * Valid surround texture keys
 */
export const VALID_SURROUND_KEYS = new Set([
	'stackedstone/graphite', 'stackedstone/chalk', 'stackedstone/terra',
	'reclaimedbrick/white',
	'weatheredwood/umber', 'weatheredwood/ash',
	'modernconcrete/bright', 'modernconcrete/industrial',
	'plank/bright', 'plank/charcoal',
	'modernstone/bright', 'modernstone/ash',
	'slatbright', 'slatwalnut', 'slatcharcoal',
	'moks/purewhite', 'moks/pitchblack', 'moks/slategray',
	'scratchcoat'
]);

/**
 * Valid countertop texture keys
 */
export const VALID_COUNTERTOP_KEYS = new Set([
	'chiseledhickory', 'chiseledcloudy', 'chiseledsmoky',
	'cleanedgehickory', 'cleanedgecloudy', 'cleanedgesmoky', 'cleanedgeslate',
	'granite|fantasybrown', 'granite|steelgray', 'granite|venetiangold',
	'granite|viscountwhite', 'granite|alfawhite', 'granite|thunderwhite', 'granite|giallowhite',
	'moks|doveshimmer', 'moks|galacticice', 'moks|asteroidterrazzo',
	'none'
]);

/**
 * Get a valid surround texture key, falling back to a default if the key is invalid
 */
export const normalizeSurroundKey = (key: string | undefined): string => {
	if (!key) return 'stackedstone/graphite';
	if (VALID_SURROUND_KEYS.has(key)) return key;
	console.warn(`KitchenSceneBuilder: Unknown surround key "${key}", using fallback "stackedstone/graphite"`);
	return 'stackedstone/graphite';
};

/**
 * Get a valid countertop texture key, falling back to a default if the key is invalid
 */
export const normalizeCountertopKey = (key: string | undefined): string => {
	if (!key) return 'granite|steelgray';
	if (VALID_COUNTERTOP_KEYS.has(key)) return key;
	console.warn(`KitchenSceneBuilder: Unknown countertop key "${key}", using fallback "granite|steelgray"`);
	return 'granite|steelgray';
};

/**
 * Known corner trim keys for surround-to-trim mapping
 */
const knownCornerKeys = new Set([
	'stackedstone/graphite-corner', 'stackedstone/chalk-corner', 'stackedstone/terra-corner',
	'reclaimedbrick/white-corner',
	'weatheredwood/umber-corner', 'weatheredwood/ash-corner',
	'modernconcrete/bright-corner', 'modernconcrete/industrial-corner',
	'plank/bright-corner', 'plank/charcoal-corner',
	'modernstone/bright-corner', 'modernstone/ash-corner',
	'slatbright-corner', 'slatwalnut-corner', 'slatcharcoal-corner',
	'moks/purewhite-corner', 'moks/pitchblack-corner', 'moks/slategray-corner',
	'scratchcoat-corner'
]);

/**
 * Get the trim key that corresponds to a surround key
 */
export const getTrimKeyForSurround = (surroundKey: string): string => {
	const cornerKey = `${surroundKey}-corner`;
	if (knownCornerKeys.has(cornerKey)) return cornerKey;
	return 'stackedstone/graphite-corner';
};
